<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn" @click="loadIndexTeaData()"></div>-->
    <div id="contentDiv">

      <!--我的任务-->
     <!-- <div id="newTaskMsgDiv" class="showMsgDiv">
        <div class="divHead">
          <div class="divHead_title">
            <div class="num_tip" :class="{tip_need: newTaskNum != ''}">{{newTaskNum}}</div>最新任务消息
          </div>
          <span @click="changeMenuClass('/task_tea')">
            <router-link to="/task_tea">更多&gt;&gt;</router-link>
          </span>
        </div>
        <div class="divBody">
          <table class="table table-striped tabShow">
            <tbody>
            <tr v-for="(task, index) in newTaskList" :key="index">
              <td style="width: 0%;"><div class="noRead_tip" :class="{tip_need: task.status == 0}"></div></td>
              <td class="tabTd_content_ellipsis tabTd_content_one" :title="task.content">
                {{task.content}}
                <span>提交截止日期：{{task.submitTime}}</span>
              </td>
              <td class="tabTd_content_ellipsis tabTd_time_one" :title="task.createTime">{{task.createTime}}</td>
              <td class="tabTd_btn_one">
                <button type="button" class="btn btn-default btn_option" @click="saveDataIntoStorage(task.clazzId)">去查看</button>
                <button type="button" class="btn btn-default btn_option" v-if="task.status == 0" @click="ignoreTask(task.id)">忽略</button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>-->

      <!--作业批改记录-->
      <div id="homeworkUploadDiv" class="showMsgDiv">
        <div class="divHead">
          <div class="divHead_title">
            <div class="num_tip"></div>作业批改记录
          </div>
          <span @click="changeMenuClass('/homeworkManage_tea')">
            <router-link to="/homeworkManage_tea">更多&gt;&gt;</router-link>
          </span>
        </div>
        <div class="divBody">
          <table class="table table-striped tabShow homework_tab">
            <thead>
            <tr>
              <th width="25%">班级名称</th>
              <th width="30%">作业内容</th>
              <th width="15%">批改进度</th>
              <!--  <th>开始日期</th>
                <th>完成日期</th>-->
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(record, index) in markingRecordList" :key="index">
              <td width="25%">{{record.clazzName}}</td>
              <td width="30%" class="tabTd_content_ellipsis" :title="record.schoolworkName">{{record.schoolworkName}}</td>
              <td width="15%" :class="{font_read: record.endSchoolworkNum!=record.schoolworkNum}">
                {{record.endSchoolworkNum}} / {{record.schoolworkNum}}
              </td>
              <!-- <td>{{record.startTime}}</td>
               <td>{{record.endTime}}</td>-->
              <td width="15%">
                <div v-if="record.clazzStatus == 1" class="edit_pic" :class="{show_edit_pic: record.clazzStatus == 1}" @click="saveDataIntoStorage(record.schoolworkId,record.clazzStatus)" data-toggle="tooltip" data-placement="bottom" title="编辑"></div>
                <div v-else class="edit_pic"></div>
                <div class="details_pic" @click="saveDataIntoStorage(record.schoolworkId,record.clazzStatus)" data-toggle="tooltip" data-placement="bottom" title="详情"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import {schoolAxios} from "../main";

  import {getContentSize} from './mainView';

  import mainViewVue from './mainView';

  export default {
    name: "indexTea",
    data() {
      return {
        //任务
        newTaskList: [],
        newTaskNum: '',

        //批改记录
        markingRecordList: [],
      }
    },
    filters: {

    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.loadIndexTeaData();
      });
    },
    methods: {
      /**
       * 初始加载数据
       */
      loadIndexTeaData() {
        let this_ = this;
        axios.all([
          schoolAxios({
            method: 'get',
            url: 'tasks/findList',
            params: {}
          }),
          schoolAxios({
            method: 'get',
            url: 'schoolwork/getSchoolWorkMsg',
            params: {
              page:'1',
              rows:'15',
              index:0,
            }
          }),
        ]).then(
          axios.spread(function (taskResp, homeResp) {
            //最新任务消息
            let taskData = taskResp.data;
            if (taskData.success) {
              this_.newTaskList = taskData.list;
              this_.loadNewTaskNum();
            }

            //批改记录
            let homeworkData = homeResp.data;
            if (homeworkData.success) {
              this_.markingRecordList = homeworkData.list;
            }
          })
        );
      },

      /**
       * 加载最新任务条数
       */
      loadNewTaskNum(){
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/getCountBy',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
            this_.newTaskNum = data.data!=0?data.data:'';
          }
        })
      },

      /**
       * 重载任务数据
       */
      reloadTasksMsg() {
        let this_ = this;
        schoolAxios({
          method: 'get',
          url: 'tasks/findList',
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            this_.newTaskList = data.list;
            this_.loadNewTaskNum();
          }
        })
      },
      /**
       * 任务忽略
       */
      ignoreTask(id) {
        let this_ = this;
        schoolAxios({
          method: 'put',
          url: 'tasks/edit/' + id,
          params: {}
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            this_.reloadTasksMsg();
          } else {
            "操作失败".showMessage();
          }
        })
      },

      /**
       * 点击修改或编辑时查看详情数据
       */
      saveDataIntoStorage(tea_schoolworkId,tea_clazzStatus){
        let this_ = this;
        //保存或修改

        this_.$store.set("tea_schoolworkId", tea_schoolworkId);
        this_.$store.set("tea_clazzStatus", tea_clazzStatus);

        //路由跳转
        this_.$router.push({
          name: 'HomeworkManageDetailsTea'
        });
      },
      /**
       * 手动改变菜单样式
       * @param path
       */
      changeMenuClass(path){
        let this_ = this;
        mainViewVue.methods.changeMenuClass(path);
      }
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/indexTea.css";
</style>



// WEBPACK FOOTER //
// src/components/indexTea.vue